import { lazy } from 'react';

export const AsyncTermsPageContainer = lazy(() => import(
  /* webpackChunkName: 'terms_page' */
  './TermsPageContainer'
));
